import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import PickupNoteList from "../Pages/PickupNotes/PickupNoteList";
import CreatePickupNote from "../Pages/PickupNotes/CreatePickupNote";
import EditPickupNote from "../Pages/PickupNotes/EditPickupNote";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <PickupNoteList />
              </AccessControl>
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <CreatePickupNote />
              </AccessControl>
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                allowedPermissions={["can_view_pickup_request"]}
                renderNoAccess={<PermissionRequired />}
              >
                <EditPickupNote />
              </AccessControl>
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
